// The menu-test comments family lib: the narrowest of the family. Quotes and a cloud, both always
// available, so nothing is filtered and there is no view mode to heal. The key is the block's own -
// comments carry no linked answer to pin to.

import {
  OE_DEFAULT_CONFIG,
  OE_PRESET_OPTIONS,
  getQuestionCodeBooks,
  getQuestionSentiments,
  getQuestionTags
} from '@aytm/app/stats/page/question-views/oe/lib/family'

export const MN_VIEW_MODES_OPTIONS = [
  { key: 'verbatim', text: 'Quote tiles' },
  { key: 'wordcloud', text: 'Wordcloud' }
]

// comments carry no sentiments and no codebooks, so no view mode draws a chart and there is
// nothing to heal
export const MN_COMMENTS_CHART_VIEW_MODES = []
export const MN_COMMENTS_HEALS_VIEW_MODE = false

export const MN_FAMILY_LIB = {
  viewModesOptions: MN_VIEW_MODES_OPTIONS,
  presetOptions: OE_PRESET_OPTIONS,
  defaultConfig: OE_DEFAULT_CONFIG,
  getKey: key => key,
  getQuestionCodeBooks,
  getQuestionTags,
  getQuestionSentiments,
  getViewModesOptions: () => MN_VIEW_MODES_OPTIONS,
  getDefaultViewMode: () => 'verbatim'
}
